import type { ExpiredCertRow } from '@cls/shared';
import { CompSection, EmptyOk } from '../CompSection.js';

interface Props {
  rows: ExpiredCertRow[];
  onWorker: (id: string) => void;
}

export function ExpiredCertsSection({ rows, onWorker }: Props) {
  return (
    <CompSection title={`✗ Expired Certificates (${rows.length})`} type="danger">
      {rows.length ? (
        <table>
          <thead>
            <tr>
              <th>Worker</th>
              <th>Role</th>
              <th>Certificate</th>
              <th>Expired</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={`${r.workerId}-${r.certType}-${i}`}>
                <td style={{ cursor: 'pointer' }} onClick={() => onWorker(r.workerId)}>
                  {r.workerName}
                </td>
                <td>{r.role}</td>
                <td style={{ color: 'var(--danger)', fontWeight: 600 }}>{r.certType}</td>
                <td style={{ color: 'var(--danger)' }}>{r.expiry}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <EmptyOk message="No expired certificates" />
      )}
    </CompSection>
  );
}
